export default __webpack_public_path__ + "static/media/fw11_277_Irshath_Ahamed.bcad55dd.pdf";